// Static reportid used to identify the login/landing page event (not a real PowerBI report).
export const LOGIN_LANDING_REPORT_ID = 'LOGIN_EVENT_0001';
export const LOGIN_LANDING_SUBREPORT_NAME = 'Landing Page';

interface PowerBiEventLogEntry {
  userid: string;
  reportid: string;
  subreportname: string | undefined;
  creationtime: string;
}

export const logPowerBiUserEvent = (
  userEmail: string | undefined | null,
  reportId: string | undefined | null,
  subReportName: string | undefined | null,
) => {
  const isProduction = process.env.NODE_ENV === 'production';
  if (!reportId || !userEmail) return;
  if (isProduction && !subReportName) return;

  const datatoApi: PowerBiEventLogEntry[] = [
    {
      userid: userEmail,
      reportid: reportId,
      subreportname: subReportName ?? undefined,
      creationtime: new Date().toISOString(),
    },
  ];

  fetch(`${process.env.REACT_APP_POWERBI_EVENT_LOG}`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(datatoApi),
  });
};
